import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UniversityRoutingModule} from './university-routing.module';
import {UniversityComponent} from './university.component';
import {AddUniversityComponent} from './add-university/add-university.component';
import {ContentHeaderModule} from '../../layout/components/content-header/content-header.module';
import {TranslateModule} from '@ngx-translate/core';
import {CoreCommonModule} from '../../../@core/common.module';
import {CardSnippetModule} from '../../../@core/components/card-snippet/card-snippet.module';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {CoreSidebarModule} from '../../../@core/components';
import {NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';


@NgModule({
    declarations: [UniversityComponent, AddUniversityComponent],
    imports: [
        CommonModule,
        UniversityRoutingModule,
        ContentHeaderModule,
        TranslateModule,
        CoreCommonModule,
        CardSnippetModule,
        NgxDatatableModule,
        CoreSidebarModule,
        NgbPaginationModule
    ],
    exports: [UniversityComponent, AddUniversityComponent]
})
export class UniversityModule {
}
